<template>
	<div
		class="fill-height"
		style="background-color: rgb(238 238 238);"
	>
		<dashboard-core-app-bar />

		<dashboard-core-drawer />

		<v-main>
			<router-view />
		</v-main>

	</div>
</template>

<script>
	import DashboardCoreAppBar from "./core/AppBar";
	import DashboardCoreDrawer from "./core/Drawer";
	export default {
		name: "dashboard-index",

		components: {
			DashboardCoreAppBar,
			DashboardCoreDrawer,
		},

		data: () => ({
			expandOnHover: false,
		}),
	};
</script>
